import { render, staticRenderFns } from "./CareerYagiofferEdit.vue?vue&type=template&id=237507b3&scoped=true"
import script from "./CareerYagiofferEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CareerYagiofferEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CareerYagiofferEdit.vue?vue&type=style&index=0&id=237507b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237507b3",
  null
  
)

export default component.exports